import { createWizardToStep } from "@/lib/blueprint-onboarding"
import { type OnboardingRouteNames } from "@/routes/onboarding"
import { type OnboardingSerializedState, type OnboardingState } from "../types/onboardingState"
import { onboardingWizard } from "../utils/createOnboardingNextWizard"

export const useOnboardingToStep = createWizardToStep<
    typeof OnboardingRouteNames,
    OnboardingState,
    OnboardingSerializedState
>(onboardingWizard)
